export default __webpack_public_path__ + "static/media/no-annual-fee-ribbon.88846ff8.svg";